import {
  GET_TEMP_DATA,
  GET_TEMP_DATA_SUCCESS,
  ADD_PUSH_ITEM,
  ADD_PUSH_ITEM_SUCCESS,
  DELETE_REMOVE_ITEM,
  DELETE_REMOVE_ITEM_SUCCESS,
  COMMON_FUNCTIONS_MANAGEMENT_API_ERROR,
  UPDATE_PUSH_ITEM,
  } from "./actionTypes"
  
  
  export const getTempData = record => ({
    type: GET_TEMP_DATA,
    payload: record,
  })

  export const getTempDataSuccess = record => ({
    type: GET_TEMP_DATA_SUCCESS,
    payload: record,
  })

  export const addPushItem = record => ({
    type: ADD_PUSH_ITEM,
    payload: record,
  })
  
  export const addPushItemSuccess = record => ({
    type: ADD_PUSH_ITEM_SUCCESS,
    payload: record,
  })

  export const updatePushItem = record => ({
    type: UPDATE_PUSH_ITEM,
    payload: record,
  })
  export const updatePushItemSuccess=record=>({
    type: UPDATE_PUSH_ITEM_SUCCESS,
    payload: record,
  })
  
  export const deleteRemoveItem = guid => ({
    type: DELETE_REMOVE_ITEM,
    payload: guid,
  })
  
  export const deleteRemoveItemSuccess = guid => ({
    type: DELETE_REMOVE_ITEM_SUCCESS,
    payload: guid,
  })

  
  export const commonFuntionsManagementApiError = error => {
    return {
      type: COMMON_FUNCTIONS_MANAGEMENT_API_ERROR,
      payload: error,
    }
  }